/* eslint-disable no-console */
// Utils

function storageAvailable( type ) {
	var storage;
	try {
		storage = window[type];
		let x = '__storage_test__';
		storage.setItem( x, x );
		storage.removeItem( x );
		return true;
	} catch ( e ) {
		return e instanceof DOMException && (
		// everything except Firefox
			e.code === 22 ||
					// Firefox
					e.code === 1014 ||
					// test name field too, because code might not be present
					// everything except Firefox
					e.name === 'QuotaExceededError' ||
					// Firefox
					e.name === 'NS_ERROR_DOM_QUOTA_REACHED' ) &&
					// acknowledge QuotaExceededError only if there's something already stored
					( storage && storage.length !== 0 );
	}
}

function setStorageItem( item, value ) {
	if ( storageAvailable( 'localStorage' ) ) {
		window.localStorage.setItem( `${item}`, `${value}` );
	}
}

function storageItemExists( item ) {
	if ( storageAvailable( 'localStorage' ) ) {
		const localItem = window.localStorage.getItem( `${item}` );
		return ( localItem );
	}
	return false;
}

// Tabs

function tabify( element ) {
	const header = element.querySelector( '.tabs' );
	const content = element.querySelector( '.panels' );
	const tabHeaders = [ ...header.children ];
	const tabContents = [ ...content.children ];
	// tabContents.forEach( x => x.style.display = 'none');
	let currentTabIndex = -1;

	function setTab( index ) {
		if ( currentTabIndex === index ) {

		}
		if ( currentTabIndex > -1 ) {
			tabHeaders[currentTabIndex].classList.remove( 'active' );
			tabContents[currentTabIndex].classList.remove( 'active' );
		}
		tabHeaders[index].classList.add( 'active' );
		tabContents[index].classList.add( 'active' );
		currentTabIndex = index;
	}

	let defaultTabIndex = tabHeaders.findIndex( x => {
		return [ ...x.classList ].indexOf( 'default-tab' ) > -1;
	} );

	defaultTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
	setTab( defaultTabIndex );
	tabHeaders.forEach( ( x, i ) => x.onclick = event => setTab( i ) );
}

[ ...document.querySelectorAll( '.tabs-container' ) ]
	.forEach( x => tabify( x ) );

// Mobile Menu trigger
const mobileMenuTrigger = document.getElementById( 'mobile-menu-trigger' );
const mobileMenu = document.getElementById( 'mobile-menu' );
const mobileMenuClose = document.getElementById( 'mobile-menu-close' );

mobileMenuTrigger.onclick = () => {
	mobileMenu.classList.toggle( 'hidden' );
};
mobileMenuClose.onclick = () => {
	mobileMenu.classList.toggle( 'hidden' );
};

// Homepage Slider

// Add PopoOver
function showComplaintsPopOver() {
	document.getElementById( 'popover-reclamatii-countdown' ).innerHTML = 5;
	let timeleft = 4;
	let downloadTimer = setInterval( function() {
		if ( timeleft <= 0 ) {
			clearInterval( downloadTimer );
			jQuery( '.block-pop-over-reclamatii' ).fadeOut( 'fast' );
			// setStorageItem( 'hasSeenComplaintsNotice', 'true' );
		} else {
			document.getElementById( 'popover-reclamatii-countdown' ).innerHTML = timeleft;
		}
		timeleft -= 1;
	}, 1000 );
}

function showPopOverData() {
	let popover = document.getElementById( 'popOverReclamatii' );
	let popoverContent = document.getElementsByClassName( 'block-pop-over-reclamatii' );

	if ( storageAvailable( 'localStorage' ) && popoverContent.length ) {
		if ( storageItemExists( 'hasSeenComplaintsNotice' ) ) {
			popover.remove();
		} else {
			popover.classList.remove( 'hidden' );
			showComplaintsPopOver();
		}
	}
}

// Handle dynamic scaling based on parent width
function applyScaling() {
	let screenParent = document.getElementsByClassName( 'site-main' )[0];
	let wrappers = screenParent.getElementsByClassName( 'scaled-wrapper' );
	const padding = 32;

	let shouldScale = window.innerWidth < 500 && wrappers.length;
	if ( ! shouldScale ) {
		return;
	}

	for ( let wrapper of wrappers ) {
		let scaledArray = wrapper.getElementsByClassName( 'scaled-content' );
		for ( let scaled of scaledArray ) {
			// Get the scaled content, and reset its scaling for an instant
			scaled.style.transform = 'scale(1, 1)';
			let { width: contentWidth, height: contentHeight } = scaled.getBoundingClientRect();
			let { width: wrapperWidth, height: wrapperHeight } = screenParent.getBoundingClientRect();

			// console.log( wrapperWidth, contentWidth, wrapperHeight, contentHeight );
			let scaleAmtX = Math.min( ( ( wrapperWidth - padding ) / contentWidth ), ( ( wrapperHeight - padding ) / contentHeight ) );
			let scaleAmtY = scaleAmtX;

			scaled.style.transform = `scale(${scaleAmtX}, ${scaleAmtY})`;
			let { width: scaledContentWidth, height: scaledContentHeight } = scaled.getBoundingClientRect();

			// console.log( scaledContentWidth, scaledContentHeight );
			wrapper.style.width = `${Math.round( scaledContentWidth )}px`;
			wrapper.style.height = `${Math.round( scaledContentHeight + 16 )}px`;
		}
	}
}

jQuery( document ).ready( function() {
	const headerNav = document.getElementById( 'masthead' );
	const homepageSlider = document.getElementById( 'homepageSlider' );
	const headerHeight = headerNav.offsetHeight;

	if ( ! jQuery( 'body' ).hasClass( 'block-editor-page' ) ) {
		jQuery( '.homepage-slider' ).on( 'init', function( slick ) {
			const initialSlideStyle = jQuery( this ).find( '.slick-slide.slick-current' ).attr( 'data-navbar-style' );
			headerNav.classList.add( initialSlideStyle );
		} );

		jQuery( '.homepage-slider' ).slick( {
			infinite: true,
			speed: 500,
			fade: false,
			cssEase: 'ease-in-out',
			arrows: false,
			dots: true,
			autoplay: true,
			autoplaySpeed: 8000,
			appendDots: '.homepage-slider-dots',
			dotsClass: 'flex flex-row items-center justify-start space-x-4',
			// appendArrows: '.homepage-slider-arrows',
			customPaging: function( slider, i ) {
				return '<i class="inline-block w-8 md:w-16 h-1 rounded-full bg-gray-500 md:bg-white opacity-25 homepage-slider--dot"></i>';
			},
		} );

		jQuery( '.homepage-slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
			// console.log(nextSlide);
			// console.log(jQuery(slick.$slides.get(nextSlide)).data());
			const requiredStyle = jQuery( slick.$slides.get( nextSlide ) ).attr( 'data-navbar-style' );

			switch ( requiredStyle ) {
				case 'dark':
					if ( headerNav.classList.contains( 'dark' ) ) {
						break;
					} else {
						headerNav.classList.remove( 'light' );
						headerNav.classList.add( 'dark' );
					}
					break;
				case 'light':
					if ( headerNav.classList.contains( 'light' ) ) {
						break;
					} else {
						headerNav.classList.remove( 'dark' );
						headerNav.classList.add( 'light' );
					}
					break;

				default:
					break;
			}
		} );
		jQuery( '.homepage-slider--prev' ).click( function() {
			jQuery( '.homepage-slider' ).slick( 'slickPrev' );
		} );

		jQuery( '.homepage-slider--next' ).click( function( e ) {
			e.preventDefault();
			jQuery( '.homepage-slider' ).slick( 'slickNext' );
		} );

		if ( homepageSlider ) {
			homepageSlider.setAttribute( 'style', `margin-top: -${headerHeight}px;` );
		}
	}
	// Focus and labels
	jQuery( '.wpcf7-form-control' ).on( 'focus', function() {
		var input = jQuery( this );
		// assuming label is the parent, i.e. <label><input /></label>
		var label = jQuery( this ).parent().parent();
		label.addClass( 'focussed' );
		input.on( 'blur', function() {
			label.removeClass( 'focussed' );
			input.off( 'blur' );
		} );
	} );

	// Popover
	showPopOverData();

	// Scale Tables
	applyScaling();
} );
